import React, {forwardRef} from 'react';
import classnames from 'classnames';
import * as S from '../CTA.styles';
import {TripInfoSubDetailsWrap} from '../../../myTripsListing/ListingBody/BookingCard/BookingCardInfoHead/BookingCardInfoHead.styles';

const Button = forwardRef((props, ref) => {
  const {
    id,
    customClasses,
    form,
    label,
    width,
    type,
    iconClass,
    leftIconClass,
    onClick,
    nature = 'button',
    style,
    isDisable = false,
    disabled = false,
  } = props;

  return (
    <S.Wrapper>
      <button
        id={id}
        form={form}
        className={classnames(type, customClasses, style?.customClasses, {
          disabledBtn: isDisable || disabled,
        })}
        style={{width}}
        onClick={!isDisable ? onClick : null}
        type={nature}
        disabled={isDisable || disabled}
      >
        {leftIconClass && (
          <span className={classnames('appendRight10', leftIconClass)}>&nbsp;</span>
        )}
        {label}
        {iconClass && <span className={`appendLeft10 ${iconClass}`}>&nbsp;</span>}
      </button>
    </S.Wrapper>
  );
});

export default Button;
